import React from "react";
/* asset imports */
import fruitsCart from "../assets/images/fruits/fruits-cart.png";

const FruitsCart = ({ handleCartClick }) => {
  return (
    <div className="fruits-cart" onClick={() => handleCartClick(1)}>
      <img src={fruitsCart} alt="" />
    </div>
  );
};

export default FruitsCart;
